import { initialStreamSliders } from "./newMainPage";
import { throttle } from "./Util";

let $targetWrap = $(".js-all-events-filters-wrap");
let $target = $(".js-stream-content");
let $notFoundBlock = $(".js-search-not-found");
let url = $target.attr("data-url");
let page = Number($target.attr("data-page"));
let currentType = [];
let currentTheme = [];

function getNewsByParams(type, theme, page) {
    $targetWrap.addClass("_loading");

    setTimeout(() => {
        $.ajax({
            url: url,
            method: "get",
            dataType: "html",
            data: {
                type: type,
                theme: theme,
                page: page,
            },
            success: function (data) {
                $targetWrap.removeClass("_loading");
                let dataObj = JSON.parse(data);
                if (dataObj.content) {
                    $target.append(dataObj.content);
                    $target.attr("data-page", page + 1);
                    
                    // Параметры фильтров в урл
                    const baseUrl =
                        window.location.protocol +
                        "//" +
                        window.location.host +
                        window.location.pathname;
                    let newUrl =
                        baseUrl + `?page=${page}&type=${type}&theme=${theme}`;

                    initialStreamSliders();
                    history.pushState(null, null, newUrl);
                } else {
                    $target.remove();
                    $notFoundBlock.addClass("_active");
                    switchRequest = false;
                }
            },
        });
    }, 150);
}

const $filters = $('.js-all-events-filters-wrap');

// показываем скрываем фильтры
$('.js-all-events-filter-btn').click(function () {
    const $el = $(this);
    if ($el.hasClass("_active")) {
        $el.removeClass("_active");
        $filters.slideUp(200);
        $el.children("span").text($el.attr("data-text-hide"));
    } else {
        $el.addClass("_active");
        $filters.slideDown(200);
        $el.children("span").text($el.attr("data-text-show"));
    }
});

$(".js-event-type").click(function () {
    const $el = $(this);
    let type = $el.attr("data-type");
    $el.toggleClass("_active");
    $target.empty();

    if ($el.hasClass("_active")) {
        currentType.push(type);
    } else {
        currentType.splice($.inArray(type, currentType), 1);
    }

    let currentValueType = currentType.length ? currentType : "all";
    let currentValueTheme = currentTheme.length ? currentTheme : "all";
    
    getNewsByParams(currentValueType, currentValueTheme, 1);
    page = 2;
});

$(".js-event-theme").click(function () {
    const $el = $(this);
    let theme = $el.attr("data-theme");
    $el.toggleClass("_active");
    $target.empty();

    if ($el.hasClass("_active")) {
        currentTheme.push(theme);
    } else {
        currentTheme.splice($.inArray(theme, currentTheme), 1);
    }

    let currentValueTheme = currentTheme.length ? currentTheme : "all";
    let currentValueType = currentType.length ? currentType : "all";

    getNewsByParams(currentValueType, currentValueTheme, 1);
    page = 2;
});

// подгрузка карточек при скролле
let showCards = false;
// флаг по которому отправляем повторно запрос только если в ответе не пусто
let switchRequest = true;

$('.js-btn-more-events').click(function () {
    const currentPage = Number($target.attr("data-page"));
    getNewsByParams(currentType, currentTheme, currentPage);
});


// WEBPACK FOOTER //
// ./_src/js/modules/Stream.js